export const ORDER_INVOICE_LIST_REQUEST = 'ORDER_INVOICE_LIST_REQUEST';
export const ORDER_INVOICE_LIST_SUCCESS = 'ORDER_INVOICE_LIST_SUCCESS';
export const ORDER_INVOICE_LIST_FAIL = 'ORDER_INVOICE_LIST_FAIL';

export const ORDER_INVOICE_DETAIL_IDLE = 'ORDER_INVOICE_DETAIL_IDLE';
export const ORDER_INVOICE_DETAIL_REQUEST = 'ORDER_INVOICE_DETAIL_REQUEST';
export const ORDER_INVOICE_DETAIL_SUCCESS = 'ORDER_INVOICE_DETAIL_SUCCESS';
export const ORDER_INVOICE_DETAIL_FAIL = 'ORDER_INVOICE_DETAIL_FAIL';
